<form [formGroup]="standingAuthorizationDetailsGroup" id="internal-transfer-details-form">
    <mm-banners data-testid="server-error" *ngIf="showServerError" [bannerText]="[serverErrorText]"
        [type]="'error'"></mm-banners>
    <mm-banners data-testid="server-error-invalid-digital-to-pdf" *ngIf="isInvalidDigitalToPdfToAccount"
        [bannerText]="[toAccountValidationError]" [type]="'error'">
    </mm-banners>
    <mm-it-to-account-number [parentForm]="standingAuthorizationDetailsGroup" [info$]="info$"
        [toAccountState$]="toAccountState$" [labelName]="'Receiving account number'"></mm-it-to-account-number>
    <mm-banners data-testid="401k-warning" *ngIf="is401k"
        [htmlStr]="[warningText401kIneligableForEauth]" [type]="'warning'"></mm-banners>
    <mm-authorization-nickname [parentForm]="standingAuthorizationDetailsGroup"></mm-authorization-nickname>
    <hr *ngIf="(inputCallFinished$ | async) && (isIra$ | async)">
    <mm-sa-it-tax-withholdings *ngIf="(inputCallFinished$ | async) && (isIra$ | async)"
        [parentForm]="standingAuthorizationDetailsGroup"></mm-sa-it-tax-withholdings>
</form>